import api from './api';
import { Notification } from '../types/notification';
import { handleError } from '../utils/errorHandler';

interface NotificationsResponse {
  count: number;
  results: Notification[];
}

export const fetchNotifications = async (): Promise<NotificationsResponse> => {
  try {
    const response = await api.get('/core/notificacoes');
    return response.data;
  } catch (error) {
    handleError(error, 'ao buscar notificações');
    throw error;
  }
};